import React from 'react';
import { Progress } from 'reactstrap';

function ProgressBar({ percentage, color,px }) {
 /*
  to adjust size of component we have used px or width
  */
  let width 
  px? width = '100px':width='100%'
  

  if (percentage > 0) {
    return (
        
      <div
        className='progress'
        style={{ width: width, }}

      >
        <div
          
          className={color==='success'?'progress-bar bg-success':"progress-bar"}
          role='progressbar'
          style={{ width: percentage+"%" ,minWidth: percentage < 10 ? '1.1rem' : '1.5rem',}}
          aria-valuenow={percentage}
          aria-valuemin='0'
          aria-valuemax='100'
        >
          {percentage}%
        </div>
      </div>
      
    );
  } else {
    return (
      <div
        className='progress'
        style={{
          width: width,

        }}
      >
        <div
          className='progress-bar'
          role='progressbar'
          aria-valuenow='60'
          aria-valuemin='0'
          aria-valuemax='100'
          style={{
            minWidth: '100%',
            width: '100%',
            // marginLeft: '35px',
            color: 'black',
            backgroundColor: '#E9ECEF',
          }}
        >
          0%
        </div>
      </div>
    )
  
  }
}
export default ProgressBar;
